import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";

export const FACILITY_STATUS = {
  disponibile: { label: "Disponibile", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  in_manutenzione: { label: "In manutenzione", cls: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  chiusa: { label: "Chiusa", cls: "bg-red-50 text-red-700 border-red-200", dot: "bg-red-500" },
};

export const PAYMENT_STATUS = {
  da_pagare: { label: "Da pagare", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  pagato: { label: "Pagato", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  esente: { label: "Esente", cls: "bg-slate-100 text-slate-700 border-slate-200" },
};

export const BOOKING_STATUS = {
  confermata: { label: "Confermata", cls: "bg-slate-900 text-white border-slate-900" },
  in_attesa: { label: "In attesa", cls: "bg-white text-slate-700 border-slate-300 border-dashed" },
  annullata: { label: "Annullata", cls: "bg-white text-slate-400 border-slate-200 line-through" },
};

export const APPLICANT_TYPES = {
  privato: "Persona fisica",
  associazione: "Associazione",
  azienda: "Azienda",
  ente: "Ente / Istituzione",
};

export const TARIFF_TYPES = {
  oraria: "Tariffa oraria",
  giornaliera: "Tariffa giornaliera",
  forfait: "Importo forfettario",
  gratuita: "Gratuita / patrocinio",
};

export const LOG_KINDS = {
  cambio_stato: "Cambio stato",
  nota: "Nota",
  segnalazione: "Segnalazione",
};

export const FACILITY_COLORS = {
  narzio: { chip: "bg-[#8B1E2B] text-white", dot: "bg-[#8B1E2B]" },
  biblioteca: { chip: "bg-sky-800 text-white", dot: "bg-sky-800" },
  vignola: { chip: "bg-emerald-800 text-white", dot: "bg-emerald-800" },
  rocca: { chip: "bg-amber-700 text-white", dot: "bg-amber-700" },
};

export const facilityColor = (slug) => FACILITY_COLORS[slug] || { chip: "bg-slate-700 text-white", dot: "bg-slate-700" };

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n) || 0);

export const fmtDate = (iso, pattern = "d MMM yyyy") => (iso ? format(parseISO(iso), pattern, { locale: it }) : "—");

export const fmtDateTime = (iso) => (iso ? format(parseISO(iso), "d MMM yyyy, HH:mm", { locale: it }) : "—");

export const todayISO = () => format(new Date(), "yyyy-MM-dd");
